import { Component, ViewChild } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiUrlHelper } from '../../../common/api-url-helper';
import { StateService } from '../../../services/common/claim-year.service';
import { CommonService } from '../../../services/common/common.service';
import { MatTabGroup } from '@angular/material/tabs';
import { Router } from '@angular/router';
import { ClaimWorkFlowItemStatusDropDownService } from '../../../services/common/claim-work-flow-item-status-drop-down.service';
import { CommonErrorMessages } from '../../../constants/error-messages';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from '../../../services/shared-service/shared.service';
import { commonLabelConstants } from '../../../constants/label-constants';
import { RoleRightsService } from '../../../services/common/role-rights.service';
import { Subject, takeUntil } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { HttpResponse } from '@angular/common/http';
import { ValidationService } from '../../../services/common/validation-service';

@Component({
  selector: 'app-expenditure-cost-category',
  templateUrl: './expenditure-cost-category.component.html',
  styleUrl: './expenditure-cost-category.component.scss',
})
export class ExpenditureCostCategoryComponent {
  haveOnlyViewPermission: boolean = false;
  selectedTab: string = ''; // Default tab is Summary
  companyId: any = 0;
  claimYearId: any = 0;
  costCategoryRights: any = {};
  expenditureCount: any = {};
  @ViewChild('tabGroup') tabGroup: MatTabGroup | undefined;
  onDestroy$: Subject<void> = new Subject();
  isDataAvailable: boolean = false;
  claimWorkFlowItemStatusList: any[] = [];
  claimWorkFlowItemStatus: any;
  isLocked: boolean = false;
  commonErrorConstants = CommonErrorMessages;
  claimWorkflowItemStatusId: any;
  commonLabelConstants = commonLabelConstants;
  env: any = environment;
  claimByProjectList : any = [];
  staffing : number = 0;
  epwUnconnected : number = 0;
  epwConnected : number = 0;
  contractorUnconnected : number = 0;
  contractorConnected : number = 0;
  software : number = 0;
  dataLicnece : number = 0;
  cloudComputing : number = 0;
  waterFuelPower : number = 0;
  consumableItems : number = 0;
  paymentToClinicalTrialParticiant : number = 0;
  total : number = 0;

  constructor(
    private readonly commonService: CommonService,
    private readonly sharedService: SharedService,
    private readonly sharedDataService: StateService,
    private readonly spinner: NgxSpinnerService,
    private readonly api: ApiUrlHelper,
    private readonly router: Router,
    private readonly toaster: ToastrService,
    private readonly claimWorkFlowItemStatusService: ClaimWorkFlowItemStatusDropDownService,
    private readonly roleRightsService: RoleRightsService,
    private readonly validationService: ValidationService
  ) {}

  ngOnInit(): void {
    this.roleRightsService.hasAccess('isAdd');
    this.sharedService.setData('Qualifying Expenditure by Cost Category');
    this.sharedDataService.companyId$.subscribe((companyId) => {
      this.companyId = companyId;
    });
    this.sharedDataService.yearId$.pipe(takeUntil(this.onDestroy$)).subscribe((yearId) => {
      this.claimYearId = yearId;
      if (
        this.companyId != null &&
        this.companyId != 0 &&
        this.companyId != undefined &&
        !isNaN(this.companyId) &&
        this.claimYearId != null &&
        this.claimYearId != 0 &&
        this.claimYearId != undefined &&
        !isNaN(this.claimYearId)
      ) {
        this.GetUserCostCategoryRights(this.companyId, this.claimYearId);
        this.getSummaryOfExpenditure(this.companyId, this.claimYearId);
        this.GetClaimByProject(this.companyId, this.claimYearId);
        this.claimWorkFlowItemStatusList =
          this.claimWorkFlowItemStatusService.getClaimWorkFlowItemStatus();
      }
    });
    this.sharedService.gethaveOnlyViewPermission().subscribe((data) => {
      this.haveOnlyViewPermission = data;
    });
  }

  onTabChange(event: any) {
    this.roleRightsService.dataFetched = false;
    const tabLabel = event.tab.textLabel; // Get the label of the selected tab
    this.selectedTab = tabLabel.toLowerCase().replace(/\s+/g, ''); // Format the label to match the condition names
  }

  summaryClick(tab: any) {
    this.selectedTab = tab;
    const tabIndex = this.getTabIndexById(tab);
    if (tabIndex !== undefined && this.tabGroup) {
      this.tabGroup.selectedIndex = tabIndex;
    }
  }

  getTabIndexById(tabId: string): any {
    const tabs = this.tabGroup?._tabs.toArray();
    if (!tabs) return undefined;
    const tab = tabs.find((t: any) => t.textLabel === tabId);
    return tab ? tabs.indexOf(tab) : undefined;
  }

  GetUserCostCategoryRights(companyId: any, claimYearId: any) {
    this.spinner.show();
    let api = this.api.apiUrl.MenuList.GetUserCostCategoryRights;
    var obj = {
      companyId: companyId,
      claimYearId: claimYearId,
    };
    this.commonService
      .doPost(api, obj)
      .pipe()
      .subscribe({
        next: (response) => {
          if (response.success) {
            this.costCategoryRights = response.data;
            this.isDataAvailable = Object.values(this.costCategoryRights).some(
              (value) => value === true
            );
          } else {
            this.costCategoryRights = {};
            this.isDataAvailable = false;

          }
          this.spinner.hide();
        },
        error: (error: any) => {
          console.log(error);
          this.spinner.hide();
        },
        complete: () => {},
      });
  }

  getSummaryOfExpenditure(companyId: any, claimYearId: any) {
    this.spinner.show();
    let api = this.api.apiUrl.MenuList.GetSummaryOfExpenditure;
    const segments = this.router.url.split('/');
    const lastSegment = '/' + segments.pop();
    var obj = {
      companyId: companyId,
      claimYearId: claimYearId,
      url: lastSegment,
    };
    this.commonService
      .doPost(api, obj)
      .pipe()
      .subscribe({
        next: (response) => {
          if (response.success) {
            this.expenditureCount = response.data;
            this.claimWorkFlowItemStatus =
              this.expenditureCount?.itemStatusId ?? 0;
            this.claimWorkflowItemStatusId =
              this.expenditureCount?.claimWorkflowItemStatusId ?? 0;
            this.isLocked = this.expenditureCount?.isLocked ?? 0;
          } else {
            this.costCategoryRights = {};
          }
          this.spinner.hide();
        },
        error: (error: any) => {
          console.log(error);
          this.spinner.hide();
        },
        complete: () => {},
      });
  }

  GetClaimByProject(companyId: any, claimYearId: any) {
    const segments = this.router.url.split('/');
    var lastSegment = segments.pop() ?? '';
    let api = this.api.apiUrl.Claim.GetClaimByProject;

    var model = {
      companyId: companyId,
      claimYearId: claimYearId,
      url: lastSegment,
    };

    this.commonService
      .doPost(api, model)
      .pipe()
      .subscribe({
        next: (response) => {
          if (response.success) {
            if (response.data[0].projectId === 0) {
              this.isLocked = response.data[0]?.isLocked ?? false;
              this.claimWorkFlowItemStatus =
                response.data[0]?.itemStatusId ?? 0;
              this.claimWorkflowItemStatusId =
                response.data[0]?.claimWorkflowItemStatusId ?? 0;
              this.claimByProjectList = [];
              this.calculateTotals();
            } else {
              this.claimByProjectList = response.data;
              this.isLocked = response.data[0]?.isLocked ?? false;
              this.calculateTotals();
              this.claimWorkFlowItemStatus =
                this.claimByProjectList[0]?.itemStatusId ?? 0;
              this.claimWorkflowItemStatusId =
                this.claimByProjectList[0]?.claimWorkflowItemStatusId ?? 0;
            }
          }
        },
        error: (error: any) => {
          console.log(error);
        }
      });
  }  calculateTotals() {
    this.staffing = this.claimByProjectList.reduce(
      (sum: number, current: { staffingCost?: number }) =>
        sum + (current.staffingCost ?? 0),
      0
    );
    this.epwUnconnected = this.claimByProjectList.reduce(
      (sum: number, current: { epwUnConnected?: number }) =>
        sum + (current.epwUnConnected ?? 0),
      0
    );
    this.epwConnected = this.claimByProjectList.reduce(
      (sum: number, current: { epwConnected?: number }) =>
        sum + (current.epwConnected ?? 0),
      0
    );
    this.contractorUnconnected = this.claimByProjectList.reduce(
      (sum: number, current: { subContractorUnConnected?: number }) =>
        sum + (current.subContractorUnConnected ?? 0),
      0
    );
    this.contractorConnected = this.claimByProjectList.reduce(
      (sum: number, current: { subContractorConnected?: number }) =>
        sum + (current.subContractorConnected ?? 0),
      0
    );
    this.software = this.claimByProjectList.reduce(
      (sum: number, current: { software?: number }) =>
        sum + (current.software ?? 0),
      0
    );
    this.dataLicnece = this.claimByProjectList.reduce(
      (sum: number, current: { dataLicence?: number }) =>
        sum + (current.dataLicence ?? 0),
      0
    );
    this.cloudComputing = this.claimByProjectList.reduce(
      (sum: number, current: { cloudComputing?: number }) =>
        sum + (current.cloudComputing ?? 0),
      0
    );
    this.consumableItems = this.claimByProjectList.reduce(
      (sum: number, current: { consumableItem?: number }) =>
        sum + (current.consumableItem ?? 0),
      0
    );
    this.waterFuelPower = this.claimByProjectList.reduce(
      (sum: number, current: { utilityCost?: number }) =>
        sum + (current.utilityCost ?? 0),
      0
    );
    this.paymentToClinicalTrialParticiant = this.claimByProjectList.reduce(
      (
        sum: number,
        current: { paymentsToClinicalTrialParticipants?: number }
      ) => sum + (current.paymentsToClinicalTrialParticipants ?? 0),
      0
    );

    this.total = this.claimByProjectList.reduce(
      (
        sum: number,
        current: any
      ) => sum + (current.staffingCost ?? 0)+ (current.epwUnConnected ?? 0)+ (current.epwConnected ?? 0) + (current.subContractorUnConnected ?? 0)
      + (current.subContractorConnected ?? 0)+ (current.software ?? 0)+ (current.dataLicence ?? 0)+ (current.cloudComputing ?? 0)+ (current.consumableItem ?? 0)+ (current.utilityCost ?? 0)
       +  (current.paymentsToClinicalTrialParticipants ?? 0 ),
      0
    );
  }

  goBack(): void {
    this.router.navigateByUrl('/claim-workflow');
  }

  goCompanyInfo() {
    this.router.navigateByUrl('/claim-workflow/company-information');
  }
  claimWorkFlowItemStatusChange(event: any) {
    if (this.isLocked) {
      this.toaster.error(this.commonErrorConstants.ClaimLocked);
      return;
    }
    if (this.haveOnlyViewPermission) {
      this.toaster.error(this.commonErrorConstants.ActionNotPermitted);
      return;
    }
    const payload = {
      ClaimWorkflowItemStatusId: this.claimWorkflowItemStatusId ?? 0,
      MenuId: this.expenditureCount.menuId,
      ClaimYearId: this.claimYearId ?? 0,
      CompanyId: this.companyId ?? 0,
      ItemStatusId: event.id,
      UserId: 0,
    };
    const validatePayload = (payload: any): string | null => {
      switch (true) {
        case payload.ClaimYearId === 0:
          return this.commonErrorConstants.YearRequired;
        case payload.CompanyId === 0:
          return this.commonErrorConstants.CompanyRequired;
        default:
          return null;
      }
    };
    const validationMessage = validatePayload(payload);
    if (validationMessage) {
      this.toaster.error(validationMessage);
      return;
    }
    let api = this.api.apiUrl.Claim.SaveClaimWorkFlowItemStatus;
    this.commonService.doPost(api, payload).subscribe({
      next: (response: any) => {
        if (response.success) {
          this.toaster.success(response.message);
        } else {
          this.toaster.success(response.message);
        }
      },
      error: (err) => {},
      complete: () => {
        if (this.companyId && this.claimYearId) {
          this.getSummaryOfExpenditure(this.companyId, this.claimYearId);
        }
      },
    });
  }
  getStatus(itemStatusId: any) {
    const status =
      this.claimWorkFlowItemStatusService.getClaimWorkFlowItemStatusById(
        itemStatusId
      );
    return status[0]?.class;
  }
  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  export(): void {
    const isValid = this.validationService.validateCompanyAndYear(
      this.companyId,
      this.claimYearId
    );
    if (!isValid) {
      return;
    }
    const companyIdStr = this.companyId !== null ? String(this.companyId) : '';
    const yearIdStr = this.claimYearId !== null ? String(this.claimYearId) : '';
    let obj = {
      CompanyId: companyIdStr,
      ClaimYearId: yearIdStr,
      Url : "/claim-dashboard"
    };
    this.spinner.show();
    let api = this.api.apiUrl.SummaryResource.ExportQualifyingExpenditure;
    this.commonService.doDownloadPost(api, obj).subscribe(
      (response: HttpResponse<Blob>) => {
        this.spinner.hide();
        const blob = response.body as Blob;
        const link = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        link.href = url;
        link.download = "Qualifying Expenditure.xlsx";

        document.body.appendChild(link);
        link.click();

        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
      },
      (error: any) => {
        this.spinner.hide();
        console.log(error);
      }
    );
  }
}
